import { Injectable, signal } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, Subject, tap } from "rxjs";
import { UserInfo } from "../../pages/profile/interfaces/profile.interface";
import { googleAuthConfig } from 'src/environments/google-auth-config';

declare const google: any;
@Injectable({
  providedIn: 'root'
})
export class GoogleAuthService {
  private client: any
  public userSubject = new Subject<UserInfo | null>();
  public isRedirectSuccess = signal<boolean>(false);
  private readonly config = googleAuthConfig; 

  constructor(private http: HttpClient) {
    this.initClient();
  }
  private async initClient(): Promise<void> {
    await this.waitForGoogle();
  }
  

  getUserInfo(token: string): Observable<UserInfo> {
    const url = `https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token=${token}`;
    return this.http.get<UserInfo>(url).pipe(
      catchError((error) => {
        console.error('Failed to get user info', error);
        return [];
      }),
      tap(userInfo => this.userSubject.next(userInfo)),
    );
  }


  signOut(): void {
    localStorage.removeItem('Authorization')
    this.userSubject.next(null)
  }

signInWithRedirect(sourcePath:'default'|'activate_promo'|'wheel', promo?:string|null): void {
  sessionStorage.setItem('google_auth_initiated', 'true');
  const scope = 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
  const { redirect_uri_default, redirect_uri_promo, client_id} = this.config;
  let redirectUri = redirect_uri_default;
  if (sourcePath === 'activate_promo') {
    redirectUri = redirect_uri_promo;
  }
let state = '';
switch(sourcePath){
  case 'wheel':
    state = encodeURIComponent(JSON.stringify({ tab: 'wheel_of_fortune', destination:'profile' }));
    break;
  case 'activate_promo':
    state = encodeURIComponent(JSON.stringify({c: promo, destination:'p'}));
    break;
  default:
    state='';
    break;
}
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=${client_id}&` +
      `redirect_uri=${encodeURIComponent(redirectUri)}&` +
      `response_type=token&` +
      `scope=${encodeURIComponent(scope)}&` +
      `prompt=consent&` +
      `state=${state}`;

    window.location.href = authUrl;
  }
  
  waitForGoogle(): Promise<void> {
  return new Promise((resolve) => {
    const checkGoogle = () => {
      if (window.google && google.accounts) {
        resolve();
      } else {
        setTimeout(checkGoogle, 50);
      }
    };
    checkGoogle();
  });
  }
}
